import { Table, Input, Card, Button } from "antd";
import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { getExercisesAPI } from "../../../../../../services/outpatient.services";
import "./exerciseMobile.css";
const ExistingExercise = ({ setSelectedExercise, setExistingModalVisible, mobile  }) => {
  const [exerciseData, setExerciseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const fetchExercises = async (search = "") => {
    try {
      setLoading(true);
      const response = await getExercisesAPI(search);
      setExerciseData(response.data || []);
    } catch (err) {
      console.error("Error fetching exercises:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExercises();
  }, []);

  const handleAddExercise = (record) => {
    setSelectedExercise({
      ...record,
      localId: Date.now(),
      time: "",
      startDate: null,
      duration: "",
      source_type: "existing",
    });
    setExistingModalVisible(true);
  };

  const columns = [
    { title: "Exercise Name", dataIndex: "name", key: "name" },
    { title: "Exercise Type", dataIndex: "exercise_type", key: "exercise_type" },
    { title: "Frequency", dataIndex: "frequency", key: "frequency" },
    { title: "Intensity", dataIndex: "intensity", key: "intensity" },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          icon={<PlusOutlined />}
          onClick={() => handleAddExercise(record)}
        />
      ),
    },
  ];

  return (
    <Card
      title="Existing Exercise"
      className={mobile ? "existing-mobile-card" : ""}
      bodyStyle={{ padding: "0 8px 8px" }}
      extra={
        <Input.Search
          placeholder="Search by name"
          allowClear
          onChange={(e) => setSearchValue(e.target.value)}
          onSearch={(val) => fetchExercises(val)}
          style={{
            width: "100%",      
            maxWidth: 250,      
            minWidth: 120,    
  }}
        />
      }
    >
      <Table
        rowKey="id"
        dataSource={exerciseData.filter((item) =>
          item.name?.toLowerCase().includes(searchValue.toLowerCase())
        )}
        columns={columns}
        pagination={{ pageSize: 6 }}
        loading={loading}
         scroll={{ x: mobile ? 700 : "max-content" }}
      />
    </Card>
  );
};

export default ExistingExercise;
